export const iconFontAwesomeArrowsArrowLeft = (
	<i className="fa-solid fa-arrow-left"></i>
);
